import clientConfig from '../../../../../../client-config';
const ProgramsUrl = clientConfig.ProgramsUrl;
const FullPath = `${ProgramsUrl}/progrmas/PLAY_MACHINES_2/BuildingInstructions_Images/MainModels`

const Pic1 = `${FullPath}/LawnMower/1_1x.png`;
const Pic2 = `${FullPath}/LawnMower/2_1x.png`;
const Pic3 = `${FullPath}/LawnMower/3_1x.png`;
const Pic4 = `${FullPath}/LawnMower/4_1x.png`;
const Pic5 = `${FullPath}/LawnMower/5_1x.png`;
const Pic6 = `${FullPath}/LawnMower/6_1x.png`;
const Pic7 = `${FullPath}/LawnMower/7_1x.png`;
const Pic8 = `${FullPath}/LawnMower/8_1x.png`;
const Pic9 = `${FullPath}/LawnMower/9_1x.png`;
const Pic10 = `${FullPath}/LawnMower/10_1x.png`;
const Pic11 = `${FullPath}/LawnMower/11_1x.png`;
const Pic12 = `${FullPath}/LawnMower/12_1x.png`;
const Pic13 = `${FullPath}/LawnMower/13_1x.png`;
const Pic14 = `${FullPath}/LawnMower/14_1x.png`;
const Pic15 = `${FullPath}/LawnMower/15_1x.png`;
const Pic16 = `${FullPath}/LawnMower/16_1x.png`;
const Pic17 = `${FullPath}/LawnMower/17_1x.png`;
const Pic18 = `${FullPath}/LawnMower/18_1x.png`;
const Pic19 = `${FullPath}/LawnMower/19_1x.png`;
const Pic20 = `${FullPath}/LawnMower/20_1x.png`;
const Pic21 = `${FullPath}/LawnMower/21_1x.png`;
const Pic22 = `${FullPath}/LawnMower/22_1x.png`;
const Pic23 = `${FullPath}/LawnMower/23_1x.png`;
const Pic24 = `${FullPath}/LawnMower/24_1x.png`;
const Pic25 = `${FullPath}/LawnMower/25_1x.png`;
const Pic26 = `${FullPath}/LawnMower/26_1x.png`;
const Pic27 = `${FullPath}/LawnMower/27_1x.png`;
const Pic28 = `${FullPath}/LawnMower/28_1x.png`;
const Pic29 = `${FullPath}/LawnMower/29_1x.png`;
const Pic30 = `${FullPath}/LawnMower/30_1x.png`;
const Pic31 = `${FullPath}/LawnMower/31_1x.png`;
const Pic32 = `${FullPath}/LawnMower/32_1x.png`;
const Pic33 = `${FullPath}/LawnMower/33_1x.png`;
const Pic34 = `${FullPath}/LawnMower/34_1x.png`;
const Pic35 = `${FullPath}/LawnMower/35_1x.png`;
const Pic36 = `${FullPath}/LawnMower/36_1x.png`;
const Pic37 = `${FullPath}/LawnMower/37_1x.png`;
const Pic38 = `${FullPath}/LawnMower/38_1x.png`;
const Pic39 = `${FullPath}/LawnMower/39_1x.png`;
const Pic40 = `${FullPath}/LawnMower/40_1x.png`;
const Pic41 = `${FullPath}/LawnMower/41_1x.png`;
const Pic42 = `${FullPath}/LawnMower/42_1x.png`;
const Pic43 = `${FullPath}/LawnMower/43_1x.png`;
const Pic44 = `${FullPath}/LawnMower/44_1x.png`;
const Pic45 = `${FullPath}/LawnMower/45_1x.png`;
const Pic46 = `${FullPath}/LawnMower/46_1x.png`;
const Pic47 = `${FullPath}/LawnMower/47_1x.png`;
const Pic48 = `${FullPath}/LawnMower/48_1x.png`;
const Pic49 = `${FullPath}/LawnMower/49_1x.png`;
const Pic50 = `${FullPath}/LawnMower/50_1x.png`;
const Pic51 = `${FullPath}/LawnMower/51_1x.png`;


export const Buildingimages = [

]
    const Pics = [
        Pic1,
        Pic2,
        Pic3,
        Pic4,
        Pic5,
        Pic6,
        Pic7,
        Pic8,
        Pic9,
        Pic10,
        Pic11,
        Pic12,
        Pic13,
        Pic14,
        Pic15,
        Pic16,
        Pic17,
        Pic18,
        Pic19,
        Pic20,
        Pic21,
        Pic22,
        Pic23,
        Pic24,
        Pic25,
        Pic26,
        Pic27,
        Pic28,
        Pic29,
        Pic30,
        Pic31,
        Pic32,
        Pic33,
        Pic34,
        Pic35,
        Pic36,
        Pic37,
        Pic38,
        Pic39,
        Pic40,
        Pic41,
        Pic42,
        Pic43,
        Pic44,
        Pic45,
        Pic46,
        Pic47,
        Pic48,
        Pic49,
        Pic50,
        Pic51,
    

    ]


    for (let i = 0; i < Pics.length; i++) {
        let obj = {};
        obj['original'] = Pics[i];
        obj['thumbnail'] = Pics[i];
        Buildingimages.push(obj);
    }

export default {
    Buildingimages,
}